import React from 'react';
import PropTypes from 'prop-types';

import SeparatorLine from '@components/SeparatorLine';
import SimpleButton from '@components/SimpleButton';

import Container from '../components/Container';
import Content from '../components/Content';
import TextContainer from '../components/TextContainer';
import Caption from '../components/Caption';
import Label from '../components/Label';
import SeparatorContainer from '../components/SeparatorContainer';
import ImageContainer from '../components/ImageContainer';
import VerticalSeparator from '../components/VerticalSeparator';
import {
  SectionButton,
  SectionButtonContainer,
} from '../components/SectionButton';

function WithCTA({
  label,
  caption,
  actionLabel,
  actionIcon,
  image,
  elementId,
  onClickButton,
  active,
}) {
  return (
    <div id={elementId}>
      <Container>
        <Content>
          {image && <ImageContainer>{image}</ImageContainer>}
          <TextContainer>
            <div>{label && <Label>{label}</Label>}</div>
            <div>
              <Caption>{caption}</Caption>
            </div>
          </TextContainer>
        </Content>
        {!actionIcon ? (
          <SimpleButton
            label={actionLabel}
            size="small"
            onClickButton={onClickButton}
          />
        ) : (
          <>
            <VerticalSeparator />

            <SectionButtonContainer active={active} onClick={onClickButton}>
              <SectionButton>
                {actionIcon}
                {actionLabel}
              </SectionButton>
            </SectionButtonContainer>
          </>
        )}
      </Container>

      <SeparatorContainer>
        <SeparatorLine />
      </SeparatorContainer>
    </div>
  );
}

WithCTA.propTypes = {
  label: PropTypes.string,
  caption: PropTypes.string,
  elementId: PropTypes.string,
  actionIcon: PropTypes.node,
  image: PropTypes.node,
  actionLabel: PropTypes.string,
  onClickButton: PropTypes.func,
  active: PropTypes.bool,
};

WithCTA.defaultProps = {
  active: true,
};

export default WithCTA;
